<div class="container-fluid"><form>
    <!-- Booking Time -->
    <div class="form-group">
      <label for="bookingTime">Booking Time:</label>
      <input type="text" class="form-control" id="bookingTime" name="bookingTime">
      <small class="form-text text-muted">
        Default circulation duration in days. This value changes the default "Return Date" in circulation form.
      </small>
    </div>
  
    <!-- Booking Quota -->
    <div class="form-group">
      <label for="bookingQuota">Booking Quota:</label>
      <input type="text" class="form-control" id="bookingQuota" name="bookingQuota">
      <small class="form-text text-muted">
        Combined maximum number of items a member can request / checkout / loan at a time.
      </small>
    </div>
  
    <!-- Enable member checkouts -->
    <div class="form-group">
      <label>Enable member checkouts:</label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="enableCheckoutsYes" name="enableCheckouts" value="yes">
        <label class="form-check-label" for="enableCheckoutsYes">Yes</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="enableCheckoutsNo" name="enableCheckouts" value="no">
        <label class="form-check-label" for="enableCheckoutsNo">No</label>
      </div>
      <small class="form-text text-muted">
        Member can do self checkout of library item through their member area. Suitable for corporate, small business, office, family and other unattended libraries.
      </small>
    </div>
  
    <!-- Enable member check-ins -->
    <div class="form-group">
      <label>Enable member check-ins:</label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="enableCheckinsYes" name="enableCheckins" value="yes">
        <label class="form-check-label" for="enableCheckinsYes">Yes</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="enableCheckinsNo" name="enableCheckins" value="no">
        <label class="form-check-label" for="enableCheckinsNo">No</label>
      </div>
      <small class="form-text text-muted">
        Member can also return items by themselves.
      </small>
    </div>
  
    <!-- Enable member check-ins for overdue items -->
    <div class="form-group">
      <label>Enable member check-ins for overdue items:</label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="enableOverdueCheckinsYes" name="enableOverdueCheckins" value="yes">
        <label class="form-check-label" for="enableOverdueCheckinsYes">Yes</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="enableOverdueCheckinsNo" name="enableOverdueCheckins" value="no">
        <label class="form-check-label" for="enableOverdueCheckinsNo">No</label>
      </div>
      <small class="form-text text-muted">
        Member can also return overdue items by themselves. This setting only works when "Enable member check-ins" is enabled.
      </small>
    </div>
  
    <!-- Member -->
    <div class="form-group">
      <label for="memberType">Member:</label>
      <select class="form-control" id="memberType" name="memberType">
        <option value="all">All Members</option>
        <option value="regular">Regular</option>
      </select>
      <small class="form-text text-muted">
        Member type who can do self checkouts and checkins.
      </small>
    </div>
  
    <!-- Checkout Time -->
    <div class="form-group">
      <label for="checkoutTime">Checkout Time:</label>
      <input type="text" class="form-control" id="checkoutTime" name="checkoutTime">
      <small class="form-text text-muted">
        Default checkout duration in days. Will be displayed in request form.
      </small>
    </div>
  
    <!-- Checkout Limit -->
    <div class="form-group">
      <label for="checkoutLimit">Checkout Limit:</label>
      <input type="text" class="form-control" id="checkoutLimit" name="checkoutLimit">
      <small class="form-text text-muted">
        Maximum checkout duration in days. Member can not exceed this limit for self checkout.
      </small>
    </div>
  
    <!-- Checkout Quota -->
    <div class="form-group">
      <label for="checkoutQuota">Checkout Quota:</label>
      <input type="text" class="form-control" id="checkoutQuota" name="checkoutQuota">
      <small class="form-text text-muted">
        Maximum number of items a member can checkout at a time.
      </small>
    </div>
  
    <!-- Submit button -->
    <button type="submit" class="btn btn-primary">Submit</button>
  </form>
  </div>